
export const SECTION = {

	ADMIN: 'section.admin',
	ADMIN_ADVANCED: 'section.admin.advanced',
	STORE: 'section.store',
	DASHBOARD: 'section.dashboard',
	CATALOG: 'section.catalog',
	PRODUCTS: 'section.products',
	ATTRIBUTES: 'section.attributes',
	ATTRIBUTE_SET: 'section.attributeset',
	ATTRIBUTE_PROPS: 'section.attributeprops',
	TAXONOMIES: 'section.taxonomies',
	GROUPS: 'section.groups',
	CUSTOMER_GROUPS: 'section.customergroup',
	SLIDER: 'section.slider',
	SHOPPING: 'section.shopping',
	CARTS: 'section.carts',
	ORDERS: 'section.orders',
	INVOICES: 'section.invoices',
	ORDER_RETURNS: 'section.orderreturns',
	COUPONS: 'section.coupons',
	PROMO_RULES: 'section.promorules',
	CUSTOMER: 'section.customer',
	CUSTOMERS: 'section.customers',
	NEWSLETTER: 'section.newsletter',
	REQUESTS: 'section.requests',
	INFLUENCERS: 'section.influencers',
	PURCHASING: 'section.purchasing',
	VENDORS: 'section.vendors',
	LOWSTOCK: 'section.lowstock',
	PURCHASE_ORDERS: 'section.purchaseorders',
	USERS: 'section.users',
	ROLES: 'section.roles',
	STOREFRONTS: 'section.storefronts',
	ZONES: 'section.zones',
	LISTS: 'section.lists',
	CMS: 'section.cms',
	CUSTOMS: 'section.customs',
	SEO: 'section.seo',
	WEB_ARTICLES: 'section.webarticles',
	I18N: 'section.i18n',
	SETTINGS: 'section.settings',
	ADVANCED_SETTINGS: 'setting.advancedsettings'
}

export const FEATURE_CREATECONF = 'feature.createconf';
export const FEATURE_PRIVATECONF = 'feature.privateconf';
export const FEATURE_IMPERSONATE = 'feature.impersonate';